import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { buy_responseApi } from "../../app/slices/buy_responseSlice";
import {
  Box,
  Button,
  IconButton,
  LinearProgress,
  Tooltip,
} from "@mui/material";
import { toast } from "react-toastify";
import NameDateSearchComponent from "../../components/customTable/NameDateSearchComponent";
import { ContentCopy } from "@mui/icons-material";
import useFilterHandler from "../../components/filterhandler";
import Loader from "../digitalGold/Loader";
import Filter from "../../components/Filter";

export default function BuyResponse() {
  const [loading, setLoading] = useState(true);
  // console.log("loading: in buy response", loading);
  const [showData, setShowData] = useState([]);
  const columnHelper = createMRTColumnHelper();

  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
    customerName: null,
  });

  const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",

    name: "",
    metalType: "",
    eyebtnforinvoice: "",
    uniqueId: "",
    transactionId: "",
    merchantTransactionId: "",

    customerRefNo: "",
  });

  const url = `/api/admin/augmont-buy-res/list`;

  const {
    handleFilterSubmit,
    handleClearFilters,
    loader,
    results,
    apiCall,
    message,
    error,
    toastTrigger,
  } = useFilterHandler(url, filterData, setFilterData);
  console.log(results, "results");
  useEffect(() => {
    apiCall(false);
  }, []);

  useEffect(() => {
    if (!message) return;

    console.log("Message updated:", message);

    if (error) {
      toast.error(message);
    }
    //   else {
    //    // toast.success(message);
    //  }
  }, [toastTrigger]);

  const sliceResponse = useSelector(
    (state) => state.buy_response.buy_response.data,
  );
  console.log("nnnnnnnnnnnn", sliceResponse);
  const stateLoading = useSelector((state) => state.buy_response.loading);

  useEffect(() => {
    if (sliceResponse?.length > 0) {
      const formattedData = sliceResponse?.map((originalData) => ({
        id: originalData._id,
        customerRefNo: originalData.customerRefNo || "N/A",
        statusCode: originalData.statusCode || "N/A",
        message: originalData.message || "N/A",
        quantity: originalData.result?.data?.quantity || "N/A",

        totalAmount: originalData.result?.data?.totalAmount || "N/A",
        preTaxAmount: originalData.result?.data?.preTaxAmount || "N/A",
        metalType: originalData.result?.data?.metalType || "N/A",
        rate: originalData.result?.data?.rate || "N/A",
        uniqueId: originalData.result?.data?.uniqueId || "N/A",
        subpartner_username:
          originalData.result?.data?.subpartner_username || "Batuk",
        partner_username: originalData.result?.data?.partner_username || "-",
        transactionId: originalData.result?.data?.transactionId || "N/A",
        userName: originalData.result?.data?.userName || "N/A",
        merchantTransactionId:
          originalData.result?.data?.merchantTransactionId || "N/A",
        mobileNumber: originalData.result?.data?.mobileNumber || "N/A",
        goldBalance: originalData.result?.data?.goldBalance || "N/A",
        silverBalance: originalData.result?.data?.silverBalance || "N/A",
        invoiceNumber: originalData.result?.data?.invoiceNumber || "N/A",
        referenceType: originalData.result?.data?.referenceType || "N/A",
        referenceId: originalData.result?.data?.referenceId || "N/A",
        partner_id: originalData.partner_id || "N/A",
        order_id: originalData.order_id || "N/A",
        flag: originalData.flag || "N/A",
        createdAt: originalData.createdAt || "N/A",
        updatedAt: originalData.updatedAt || "N/A",
      }));

      console.log("shubhamnautiyal", formattedData);
      setShowData(formattedData);
    } else {
      setShowData([]);
    }
  }, [sliceResponse]);

  const columns = [
    // columnHelper.accessor("id", {
    //   header: "ID",
    //   size: 30,
    //   Cell: (cell) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row?.original?.id);
    //       toast.success("Copied to clipboard!");
    //     };

    //     return (
    //       <Tooltip title={cell.row?.original?.id}>
    //         <IconButton onClick={handleCopy}>
    //           <ContentCopy />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 30,
      Cell: (cell) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("customerName", {
      header: "Name",
      size: 30,
    }),

    columnHelper.accessor("phone", {
      header: "Phone",
      size: 30,
    }),

    columnHelper.accessor("uniqueId", {
      header: "Unique Id",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.uniqueId);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row?.original?.uniqueId}>
            <>
              <span>
                <IconButton onClick={handleCopy}>
                  <ContentCopy />
                </IconButton>
                {cell.row.original?.uniqueId}
              </span>
            </>
          </Tooltip>
        );
      },
    }),
    // columnHelper.accessor("flag", {
    //   header: "Flag",
    //   size: 30,
    // }),
    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 30,
    }),
    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
    }),

    columnHelper.accessor("rate", {
      header: "Metal Rate",
      size: 30,
    }),

    columnHelper.accessor("preTaxAmount", {
      header: "Pre Tax Amount",
      size: 30,
    }),
    columnHelper.accessor("totalAmount", {
      header: "Total Amount",
      size: 30,
    }),
    // columnHelper.accessor("phone", {
    //   header: "Mobile No.",
    //   size: 30,
    //   Cell: (cell) => (
    //     <div style={{ textAlign: "center" }}>
    //       {cell.row.original?.phone || 0}
    //     </div>
    //   ),
    // }),
    columnHelper.accessor("merchantTransactionId", {
      header: "Merchant Transaction ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(
            cell.row.original?.merchantTransactionId,
          );
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.merchantTransactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.merchantTransactionId}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("invoiceNumber", {
      header: "Invoice Number",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.invoiceNumber);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.invoiceNumber}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.invoiceNumber}
            </span>
          </Tooltip>
        );
      },
    }),
    // columnHelper.accessor("partner_username", {
    //   header: "Partner Username",
    //   size: 30,
    // }),

    columnHelper.accessor("partner_username", {
      header: "Partner Username",
      size: 30,
      Cell: ({ cell }) => cell.getValue() || "Batuk",
    }),

    columnHelper.accessor("subpartner_username", {
      header: "Subpartner Username",
      size: 30,
      Cell: ({ cell }) => cell.getValue() || "-",
    }),
    columnHelper.accessor("payment_id", {
      header: "Payment Id",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.payment_id);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row?.original?.payment_id}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.payment_id}
            </span>
          </Tooltip>
        );
      },
    }),
    // columnHelper.accessor("partner_id", {
    //   header: "Partner Id",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row?.original?.partner_id);
    //       toast.success("Copied to clipboard!");
    //     };

    //     return (
    //       <Tooltip title={cell.row?.original?.partner_id}>
    //         <span>
    //           <IconButton onClick={handleCopy}>
    //             <ContentCopy />
    //           </IconButton>
    //           {cell.row.original?.partner_id}
    //         </span>
    //       </Tooltip>
    //     );
    //   },
    // }),
    columnHelper.accessor("order_id", {
      header: "PG OrderId",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.order_id);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row?.original?.order_id}>
            <>
              <span>
                <IconButton onClick={handleCopy}>
                  <ContentCopy />
                </IconButton>
                {cell.row.original?.order_id}
              </span>
            </>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("transactionId", {
      header: "Transaction Id",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.transactionId);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row?.original?.transactionId}>
            <>
              <span>
                <IconButton onClick={handleCopy}>
                  <ContentCopy />
                </IconButton>
                {cell.row.original?.transactionId}
              </span>
            </>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("referenceId", {
      header: "Referance Id",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.referenceId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.referenceId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.referenceId}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("referenceType", {
      header: "Referance Type",
      size: 30,
    }),

    // columnHelper.accessor("goldBalance", {
    //   header: "Gold Balance",
    //   size: 30,
    //   Cell: (cell) => (
    //     <div style={{ textAlign: "center" }}>
    //       {cell.row.original?.goldBalance || 0}
    //     </div>
    //   ),
    // }),
    // columnHelper.accessor("silverBalance", {
    //   header: "Silver Balance",
    //   size: 30,
    //   Cell: (cell) => (
    //     <div style={{ textAlign: "center" }}>
    //       {cell.row.original?.silverBalance || 0}
    //     </div>
    //   ),
    // }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => cell.row.original.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => cell.row.original.updatedAt?.split("T")[0],
    }),

    //   columnHelper.accessor("invoiceURL", {
    //   header: "Invoice",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const invoiceUrl = cell.row.original.invoiceURL;

    //     const handleViewInvoice = () => {
    //       if (!invoiceUrl) return;
    //       window.open(invoiceURL, "_blank");
    //     };

    //     return (
    //       <Button
    //         onClick={handleViewInvoice}
    //         sx={{
    //           backgroundColor: "#4a2a7d",
    //           color: "white !important",
    //         }}
    //       >
    //         View Invoice
    //       </Button>
    //     );
    //   },
    // }),
  ];

  //  columns.unshift(
  //   columnHelper.accessor("action", {
  //     header: "Action",
  //     size: 30,
  //     Cell: (cell) => (
  //       <>
  //       {cell.row.original.order_id &&
  //       <Tooltip title="Check Status">
  //         <IconButton
  //         onClick={() => handleView(cell.row.original)}
  //         color="primary"
  //         >
  //           <VisibilityOutlinedIcon />
  //         </IconButton>
  //       </Tooltip>
  //         }
  //       </>
  //     ),
  //   })
  // );

  const fetchAadharData = useCallback(() => {
    // setLoading(true);
    let params = {};
    // if (searchTerm) {
    params.name = queryParams.customerName;
    // } else if (queryParams.startDate && queryParams.endDate) {
    params.startDate = queryParams.startDate;
    params.endDate = queryParams.endDate;
    // }
    console.log(params, "params");
    if (Object.keys(params).length > 0) {
      dispatch(buy_responseApi(params));
    }

    setLoading(false);
  }, [dispatch, queryParams]);

  // useEffect(() => {
  //   fetchAadharData();
  // }, [fetchAadharData]);

  const handleSearchByDate = (startDate, endDate, customerName) => {
    setLoading(true);

    setQueryParams({ startDate, endDate, customerName });
  };

  return (
    <Box>
      <Filter
        filterData={filterData}
        onFilterSubmit={handleFilterSubmit}
        Onclear={handleClearFilters}
        page={"augmont_buy_res"}
        setFilterData={setFilterData}
      />
      {/* <Box>
        <Box
          mt={0}
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-end"
        >
          <NameDateSearchComponent onSearch={handleSearchByDate} />
        </Box>
      </Box> */}

      <Box mt={2}>
        {loader ? (
          <Loader />
        ) : (
          <CustomTable
            columns={columns}
            data={results}
            loading={loader}
            permissionKey="BuyResponse"
          />
        )}
      </Box>
    </Box>
  );
}
